import { create } from 'zustand';

let settingsPublisher = null;

export function setSettingsPublisher(publisher) {
  settingsPublisher = publisher;
}

const useEventStore = create((set, get) => ({
  eventData: null,
  participants: [],
  settings: {
    voteSkipThreshold: 50,
    guestRequestsEnabled: true,
    maxQueuePerUser: 3,
    requestCooldownMinutes: 5,
  },

  participantActivity: {},
  presenceByUid: {},

  setPresenceByUid: (presenceByUid) => set({ presenceByUid: presenceByUid || {} }),

  setEventData: (data) => {
    set({
      eventData: data,
      presenceByUid: data ? get().presenceByUid : {},
      settings: data?.settings
        ? { ...get().settings, ...data.settings }
        : get().settings,
    });
  },

  applyRemoteEvent: (fields) => {
    const current = get().eventData;
    if (!current || !fields || (fields.id && fields.id !== current.id)) {
      return;
    }

    const nextSettings = fields.settings
      ? { ...current.settings, ...fields.settings }
      : current.settings;

    set({
      eventData: {
        ...current,
        ...fields,
        id: current.id,
        settings: nextSettings,
      },
      settings: fields.settings
        ? { ...get().settings, ...fields.settings }
        : get().settings,
    });
  },

  updateSettings: (newSettings) => {
    const current = get();
    const merged = {
      ...(current.eventData?.settings || current.settings),
      ...newSettings,
    };

    set({
      settings: { ...current.settings, ...newSettings },
      eventData: current.eventData
        ? { ...current.eventData, settings: merged }
        : current.eventData,
    });

    settingsPublisher?.(newSettings);
  },

  addParticipant: (participant) => set((state) => ({
    participants: [...state.participants, participant],
  })),

  removeParticipant: (userId) => set((state) => ({
    participants: state.participants.filter((p) => p.id !== userId),
  })),

  updateParticipantRole: (userId, newRole) => set((state) => ({
    participants: state.participants.map((p) =>
      p.id === userId ? { ...p, role: newRole } : p
    ),
  })),
}));

export default useEventStore;
